module.exports = __webpack_public_path__ + "static/img/promptpay.f64b4ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/promptpay.jpg
// module id = 288
// module chunks = 1